import { render, staticRenderFns } from "./SvgChangelog.vue?vue&type=template&id=19e850c9"
import script from "./SvgChangelog.vue?vue&type=script&lang=js"
export * from "./SvgChangelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports